import { ResourceOptions } from 'react-admin';
import { MdAccountBalanceWallet } from 'react-icons/md';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.relayDeposit;
export const icon = MdAccountBalanceWallet;
export const options: ResourceOptions = {
  label: 'resource.relay-deposit',
};
